import React from 'react';
import { MarketplaceProfileModelState, MARKETPLACE_PROFILE_UI } from '../../../../store/MarketplaceProfile/MarketplaceProfile.types';

import ServiceTilesMobile from './ServiceTilesMobile';

export type MarketplaceProfileProps = {
  marketplaceProfile: MarketplaceProfileModelState;
  providerRecommendationData: any;
  providerLatitude: number;
  providerLongitude: number;
  providerCity: string;
};

export default function MarketplaceProfile({
  marketplaceProfile,
  providerRecommendationData,
  providerLatitude,
  providerLongitude,
  providerCity,
}: MarketplaceProfileProps) {
  // If mp isn't assigned or shouldn't render just return null
  if (!marketplaceProfile || !marketplaceProfile.shouldRender) return null;

  // There is a race condition in redux that needs to be accounted for
  if (!providerRecommendationData?.found) return null;

  // Conditionally render one of the UIs based on what is in the store
  if (marketplaceProfile.ui === MARKETPLACE_PROFILE_UI.SERVICE_TILES_MOBILE) {
    return (
      <ServiceTilesMobile
        providerRecommendation={providerRecommendationData}
      />
    );
  }

  if (marketplaceProfile.ui === MARKETPLACE_PROFILE_UI.PHOTO_BROWSING_MOBILE) {
    // Note: Fallback to an "okay" experience if we don't have the information
    // needed for a proper search lookup

    const hasProviderCoords = providerLatitude && providerLongitude;

    if (!hasProviderCoords || !providerCity) {
      return (
        <ServiceTilesMobile
          providerRecommendation={providerRecommendationData}
        />
      );
    }
  }

  return null;
}
